import useQuery, { QueryOptions } from "../../common/lib/fetch/useQuery";
import { useKaEmployee } from "../../userAccess/kaEmployee/useKaEmployee";

export interface PastOrder {
  orderId?: string;
  orderNumber?: string;
  loadoutGroupName?: string;
  orderNumbers?: string[];
  orderIds?: string[];
  completedAt: string;
}

export const useGetPastOrders = (siteId: string, options?: QueryOptions<PastOrder[]>) => {
  const kaEmployee = useKaEmployee();
  return useQuery<PastOrder[]>({
    headers: kaEmployee.fetchHeaders,
    path: `/api/employee/sites/${siteId}/pastOrders`,
  }, options);
}